import Header from "../components/Header";
import Hero from "../components/Hero";
import Features from "../components/Features";
import Testimonials from "../Testimonials";
import CTA from "../components/CTA";
import Footer from "../components/Footer";
import About from "../components/About";

const Home = () => {
  return (
    <div className="min-h-screen bg-background font-sans bg-slate-600">
      <Header />
      <main>
        <Hero />
        <About />
        <Features />
        <Testimonials />
        {/* <CTA /> */}
      </main>
      <Footer />
    </div>
  );
};

export default Home;
